"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCustomField = void 0;
/**
 * Parses a custom field from a CommerceTools resource if the field is a JSON string.
 *
 * @example
 * const config = parseCustomField<ProductConfiguration>(lineItem, "productConfig");
 * const dispatchInfo = parseCustomField<DispatchInfo>(order, "dispatchInfo");
 */
function parseCustomField(resource, field) {
    const customField = resource.custom?.fields?.[field];
    return customField && typeof customField === "string" ? JSON.parse(customField) : null;
}
exports.parseCustomField = parseCustomField;
